import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { getIconCSSClass } from "../../utils/index";
import BrowserViewGlobal from "../../../Views/BrowserView";
import ActionPointTooltip from "../../ActionPointTooltip";
import useHover from "../../../hooks/useHover";

export default function ImageLink({
  id,
  createNonInternalStream,
  tabindex,
  linkImage,
  setModalIsOpen,
  modalIsOpen,
  left,
  top,
  iconKind,
  title,
  backgroundColor,
}) {
  const toggle = () => setModalIsOpen(!modalIsOpen);
  const [hover, hoverProps] = useHover();

  return (
    <BrowserViewGlobal>
      <a
        id={`action-point-${id}`}
        style={{
          top: `${top}%`,
          left: `${left}%`,
          backgroundColor: `#${backgroundColor}`,
        }}
        className={`view__links__dot  ${getIconCSSClass(iconKind)}`}
        // title={title}
        onClick={() => {
          toggle();
          createNonInternalStream();
        }}
        tabindex={tabindex}
        {...hoverProps}
      >
        <ActionPointTooltip show={hover} text={title} />
      </a>
      <Modal centered show={modalIsOpen} onHide={toggle}>
        <div className="modal-custom">
          <div onClick={toggle} className="modal-custom__close">
            <div className="modal-custom__close-inner h-100 d-flex justify-content-center align-items-center">
              &#10005;
            </div>
          </div>
          <div className="modal-custom__body">
            <div>
              <img src={linkImage} style={{
                verticalAlign: "middle"
              }} />
            </div>
          </div>
        </div>
      </Modal>
    </BrowserViewGlobal>
  );
}
